import { useRef } from 'react'
import PropTypes from 'prop-types'

import { Body, Container, Input } from './styles'

const RadioButton = ({
  as,
  checked = false,
  disabled = false,
  hasError = false,
  name = '',
  onChange = () => {},
  value = '',
  'aria-label': ariaLabel,
  ...restProps
}) => {
  const inputRef = useRef()

  const focusInput = () => inputRef.current.focus()

  const wrappedOnChange = (event) => {
    onChange(event.currentTarget.checked, value, event)
  }

  return (
    <Container {...restProps}>
      <Input
        as={as}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={wrappedOnChange}
        onClick={focusInput}
        aria-label={ariaLabel}
        ref={inputRef}
      />
      <Body hasError={hasError} />
    </Container>
  )
}

RadioButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  as: PropTypes.string,
  'aria-label': PropTypes.string
}

export default RadioButton
